import { HandlingOptions, RequireOnly } from '@pelicargo/types';
import { Cargo } from '@prisma/client';

const LENGTH_THRESHOLD_IN = 125;
const WIDTH_THRESHOLD_IN = 96;
const WEIGHT_THRESHOLD_KG = 4000;

export const mayImpactCw = (cargo: RequireOnly<Cargo, 'length' | 'width' | 'weight' | 'handling'>) => {
  const isNonStackable = cargo.handling.includes(HandlingOptions.NonStackable);
  const isOverLength = cargo.length > LENGTH_THRESHOLD_IN;
  const isOverWidth = cargo.width > WIDTH_THRESHOLD_IN;
  const isOverweight = cargo.weight && cargo.weight > WEIGHT_THRESHOLD_KG;

  return isNonStackable || isOverLength || isOverWidth || isOverweight;
};
